import React, {useEffect, useRef, useState} from 'react';
import './Sidebar.scss';
import {Poi, Trip} from '../../react-app-env';
import ItineraryPoiList from '../itinerarypoilist/ItineraryPoiList';
import Stack from '../stack/Stack';
import {StackApi, StackPage} from '../stack/Stack.types';
import SidebarHeader from './SidebarHeader';
import {SidebarPage} from './SidebarPage';
import PoiDetailsSidebarPage from '../poidetails/PoiDetailsSidebarPage';
import {Events, EventType} from '../../events/Events';

export interface SidebarProps {
  trip: Trip;
}

const Sidebar: React.FC<SidebarProps> = ({ trip }) => {
  const stackApiRef = useRef<StackApi | null>(null);
  const [selectedPoiId, setSelectedPoiId] = useState<string>();

  // Initialisation ---------------------------------------------------------------------------------

  useEffect(() => {
    Events.subscribe(EventType.SELECT_POI, (poi: Poi) => {
      setSelectedPoiId(poi.id);
      stackApiRef?.current?.push(buildPoiDetailsStackPage(trip, poi));
    });
  });

  useEffect(() => {
    stackApiRef?.current?.push({
      id:           'itinerary-poi-list',
      nodeProvider: () => <SidebarPage className="itinerary">
        <SidebarHeader
            title={trip.title}
            buttons={[]}/>
        <ItineraryPoiList trip={trip}/>
      </SidebarPage>
    });
  }, [trip]);

  useEffect(() => {
    const poi = trip.pois.find(poi => poi.id === selectedPoiId);
    if (poi) {
      stackApiRef?.current?.replace(buildPoiDetailsStackPage(trip, poi));
    }
  }, [trip, selectedPoiId]);

  function buildPoiDetailsStackPage(trip: Trip, poi: Poi): StackPage {
    return {
      id:           'poi-details--' + poi.id,
      nodeProvider: () => <PoiDetailsSidebarPage trip={trip}
                                                 poi={poi}
                                                 stackApi={stackApiRef?.current!}/>
    }
  }

  // Rendering ---------------------------------------------------------------------------------

  return (
      <div className="sidebar">
        <Stack ref={stackApiRef}/>
      </div>
  );
};

export default Sidebar;
